import { useQuery } from "@tanstack/react-query";
import { getAboutHome } from "../../api/apiAbout";

export const useGetAboutHome = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["about-home"],
        queryFn: getAboutHome,
    });

    return {
        aboutHome: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
